import { PitchSlide } from '../data/slides';
import { postJson } from './request';

export interface GenerateSlideInput {
  prompt: string;
  currentSlide?: PitchSlide;
}

export const generateSlide = (input: GenerateSlideInput): Promise<{ slide: PitchSlide }> =>
  postJson<{ slide: PitchSlide }>('/api/generate-slide', input);

export interface EditDeckInput {
  prompt: string;
  deckName: string;
  slides: PitchSlide[];
}

export const editDeckWithAi = (
  input: EditDeckInput,
): Promise<{ slides: PitchSlide[]; deckName?: string }> =>
  postJson<{ slides: PitchSlide[]; deckName?: string }>('/api/edit-deck', input);
